<template>
  <div class="game-input-on-background-wrapper">
    <div v-if="objectImageExist(imageData)" class="main-image-container" :style="getImageStyle(imageData)"></div>
    <div
      class="text-element"
      v-for="(item, index) in staticText"
      :key="'text_' + index"
      :style="getStaticTextStyle(item)"
      v-html="item.text"
    ></div>
    <tr-box
      v-if="words.length"
      :items="words"
      :config="boxConfig"
      :font-size="boxConfigFontSize"
      :style="getBoxStyle(startGameConfig.boxConfig)"
      class="box-style"
    >
    </tr-box>
    <tr-text-area
      v-for="(item, index) in items"
      :key="item.id"
      :config="item"
      :tr-text-area-value="textAreaData[index]"
      :text-area-width="item.textAreaWidth || startGameConfig.textAreaWidth"
      :text-area-height="item.textAreaHeight || startGameConfig.textAreaHeight"
      :text-area-font-size="item.textAreaFontSize || startGameConfig.textAreaFontSize"
      :max-length="item.textAreaMaxLength || startGameConfig.textAreaMaxLength"
    >
    </tr-text-area>
  </div>
</template>

<script>
import _ from 'lodash';
import TrTextArea from '../TrInput/TrTextAreaV2';
import TrBox from '../../GameBaseElements/TrBox/TrBoxV2';
import * as utils from '../../Utils/inputUtilsV2';
import defaultMixin from '../../mixins/defaultMixinV2';
export default {
  name: 'tr-text-area-on-background-v2',
  components: {
    TrTextArea,
    TrBox,
  },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      words: [],
      boxConfig: {
        x: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.left) || 1,
        y: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.top) || 14,
        width: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.width) || 98,
        height: (this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.height) || 12,
        unit: '%',
      },
      textAreaData: [],
      staticText: [],
      imageData: {},
    };
  },
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.items = this.prepareData(this.startGameConfig.items);
      this.textAreaData = _.map(this.items, (item) => {
        return {
          correct: item.correct,
          val: item.value || '',
          block: item.block || false,
          inputStatus: item.inputStatus || null,
          caseSensitive: item.caseSensitive || this.caseSensitive,
        };
      });
      // console.log('  this.textAreaData', this.textAreaData);
      // this.longestWordLength = _.maxBy( this.textAreaData, ( item ) => {
      //   return item.correct.length;
      // } );
    },
    prepareData() {
      let selectedItem = {};
      let staticText = [];
      if (this.startGameConfig.pick > 1) {
        selectedItem = _.sampleSize(this.startGameConfig.items, this.startGameConfig.pick);
        // COMBAK: add merge options
      } else {
        selectedItem = this.startGameConfig;
      }
      if (selectedItem.imageData) {
        this.imageData = selectedItem.imageData;
      } else if (this.startGameConfig.mainImage) {
        this.imageData = this.startGameConfig.mainImage;
      } else if (this.startGameConfig.background) {
        this.imageData = Object.assign({}, { imagePath: this.startGameConfig.background });
      }
      if (selectedItem.pick && selectedItem.pick > 1) {
        this.items = _.sampleSize(selectedItem.items, selectedItem.pick);
      } else if (selectedItem.pick && selectedItem.pick === 1) {
        this.items = _.sample(selectedItem.items);
      } else {
        this.items = selectedItem.items;
      }
      if (this.startGameConfig.staticText) {
        staticText = staticText.length === 0 ? this.startGameConfig.staticText : staticText;
      }
      if (staticText.length > 0) {
        this.staticText = _.map(staticText, (item, index) => {
          if (this.startGameConfig.layoutStaticText) {
            return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
          } else {
            return item;
          }
        });
      }
      this.items = selectedItem.shuffle ? _.shuffle(this.items) : this.items;
      /**
       * add layout if exist
       * @method if
       * @param  {array} this layoutItems array
       * @return {Boolean}
       */
      if (this.startGameConfig.layoutItems) {
        this.items = _.map(_.cloneDeep(this.items), (item, index) => {
          return Object.assign(item, this.startGameConfig.layoutItems[index]);
          // return _.merge( item, this.startGameConfig.layoutItems[ index ] );
        });
      }
      /**
       * box  text aplay
       * @type {[type]}
       */
      if (this.startGameConfig.words) {
        this.words = _.shuffle(_.cloneDeep(this.startGameConfig.words));
      }
      return this.items;
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      this.init();
      // this.questionsList = this.processQuestionsList();
    },
    checkGameAction() {
      let status = _.reduce(
        this.textAreaData,
        (result, value, key) => {
          let temVal = null;
          let index = _.findIndex(value.correct, (o) => {
            if (value.caseSensitive) {
              return o === _.trim(value.val);
            } else {
              return o === _.trim(value.val.toLowerCase());
            }
          });
          if (index != -1) {
            temVal = result && true;
            if (value.caseSensitive) {
              value.val = _.trim(value.val);
            } else {
              value.val = _.trim(value.val.toLowerCase());
            }
            value.block = true;
            value.inputStatus = 'correct';
          } else {
            temVal = false;
            value.val = '';
            value.block = true;
            value.inputStatus = 'incorrect';
            setTimeout(() => {
              value.val = '';
              value.block = false;
              value.inputStatus = null;
            }, 1000);
          }
          return temVal;
        },
        true
      );
      // console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.textAreaData, (item, key) => {
          // console.log('item', item);
        });
      }
      return status;
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return {
        // 'position': 'absolute',
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      };
    },
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    getBoxStyle(box) {
      box.x = box.x;
      box.y = box.y;
      box.width = box.width;
      box.height = box.height;
      return _.merge(
        { position: 'absolute' },
        {
          left: utils.elementLeftPosition(box.x, 0, '%'),
          top: utils.elementTopPosition(box.y, 0, '%'),
          width: utils.elementWidth(box.width, '%'),
          height: utils.elementHeight(box.height, '%'),
        },
        this.getCustomStyle(box)
      );
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    caseSensitive() {
      return this.startGameConfig.caseSensitive;
    },
    maxCharNumber() {
      return _.round((this.longestWordLength.correct.length * 120) / 100).toString();
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
    boxConfigFontSize() {
      let fontSize = this.startGameConfig.boxConfig && this.startGameConfig.boxConfig.fontSize;
      return fontSize + 'px';
    },
  },
};
</script>

<style lang="scss" scoped>
.game-input-on-background-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  // background-image: url("~@/assets/icons/book/toolbox/przybornik_kosz.png");
  .main-image-container {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;

    background-size: contain;
    background-repeat: no-repeat;
  }
}
</style>
